import { suiteProductConfigurationsSelector } from 'pricing-pages-ui/selectors/ProductConfigsSelectors';
import { useQueryParamTerm, useValidatedCrmSuiteQueryParamTerm } from 'pricing-pages-ui/utils/urls/appQueryParamUtils';
import { useSelector } from 'react-redux';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { usePurchaseOptionsForProductsForTerm } from '../../../hooks/usePurchaseOptions';
import { currentSuiteSkuIdsForProductLevelSelector, skuIdHasBundledProductsSelector } from '../../../selectors/ProductsSelectors';
import { useShowPricePerMonthPerSeat } from '../seats-display/useSeatsDisplay';
export const useCrmSuitePricingInfo = ({
  productLevel,
  termOverride
}) => {
  const isAppReady = useGlobalLoading();
  const suiteProductConfigurations = useSelector(state => suiteProductConfigurationsSelector(state, {
    productLevel
  }));
  const {
    queryParamTerm: unbundledQueryParamTerm
  } = useValidatedCrmSuiteQueryParamTerm({
    productLevel
  });
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const hasBundledSuite = useSelector(state => suiteProductConfigurations.find(config => skuIdHasBundledProductsSelector(state, {
    skuId: config.skuId
  })));
  const bundledQueryParamTerm = hasBundledSuite ? queryParamTerm : null;
  const queryParamTermToUse = termOverride || bundledQueryParamTerm || unbundledQueryParamTerm;
  const {
    loading: loadingPricingDataForSuite,
    pricingData: pricingInfo
  } = usePurchaseOptionsForProductsForTerm({
    productConfigurations: suiteProductConfigurations,
    term: queryParamTermToUse
  });
  const loading = !isAppReady || loadingPricingDataForSuite;
  return {
    pricingInfo,
    loading
  };
};
export const useCrmSuiteBundlePricingMetadata = ({
  productLevel
}) => {
  const isAppReady = useGlobalLoading();
  const skuIds = useSelector(state => {
    if (!isAppReady) return [];
    return currentSuiteSkuIdsForProductLevelSelector(state, {
      productLevel
    });
  });

  // For showing price/mo/seat and included seats, only show for a bundled suite sku,
  // not the unbundled suite. It adds more logic than it's worth for a small cohort
  // that will eventually go away.
  const suiteSkuId = skuIds && skuIds.length === 1 ? skuIds[0] : undefined;
  const showPricePerMonthPerSeat = useShowPricePerMonthPerSeat({
    skuId: suiteSkuId
  });
  return {
    showPricePerMonthPerSeat,
    suiteSkuId
  };
};